// ========================================
// COMPONENT - SiteHead
// Gère les métadonnées dynamiques du site
// ========================================

import { useEffect } from 'react';
import useSiteSettings from '../../hooks/useSiteSettings';

const SiteHead = () => {
  const { settings } = useSiteSettings();

  useEffect(() => {
    if (!settings) return;

    // === FAVICON ===
    if (settings.favicon) {
      // Supprimer les anciens favicons
      const existingIcons = document.querySelectorAll("link[rel*='icon']");
      existingIcons.forEach(icon => icon.remove());

      // Créer nouveau favicon
      const link = document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/png';
      link.href = `${settings.favicon}?v=${Date.now()}`;
      document.head.appendChild(link);

      // Apple touch icon
      const appleLink = document.createElement('link');
      appleLink.rel = 'apple-touch-icon';
      appleLink.href = `${settings.favicon}?v=${Date.now()}`;
      document.head.appendChild(appleLink);
    }

    // === TITLE ===
    if (settings.seo?.defaultTitle || settings.siteName) {
      document.title = settings.seo?.defaultTitle || settings.siteName;
    }

    // === META DESCRIPTION ===
    if (settings.seo?.defaultDescription) {
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.name = 'description';
        document.head.appendChild(metaDesc);
      }
      metaDesc.content = settings.seo.defaultDescription;
    }

    // === OG IMAGE (pour partage social) ===
    if (settings.logo) {
      let ogImage = document.querySelector('meta[property="og:image"]');
      if (!ogImage) {
        ogImage = document.createElement('meta');
        ogImage.setAttribute('property', 'og:image');
        document.head.appendChild(ogImage);
      }
      ogImage.content = settings.logo;
    }

  }, [settings]);

  return null; // Ce composant ne rend rien visuellement
};

export default SiteHead;